import { useMemo } from "react";
import isEqual from "lodash/isEqual";

/**
 * Small shared guard for RecordNav-style forms that keep edits local until save.
 * The caller provides normalized snapshots so transient metadata does not count
 * as user-visible dirty state.
 */
export const useDirtyFormGuard = ({ originalValue, currentValue, hasError = false }) => {
	const isDirty = useMemo(
		() => !isEqual(currentValue ?? null, originalValue ?? null),
		[currentValue, originalValue]
	);

	return {
		isDirty,
		canSave: isDirty && !hasError,
		canRevert: isDirty,
	};
};

